<template>
  <div class="top_list_wrap dp_fs_color" :class="{yincang_active: chunjing}">
<!--    </div>-->
    <div class="top_list_ul_right">
      <div class="top_list_li" @click="showLayer(2)">
        <div class="top_list_text_wrap">
          <p class="top_tit">
            当前报警数
          </p>
          <div class="top_sum baojing_sum default_color"></div>
        </div>
<!--        <img :src="quanImg" alt="">-->
      </div>
      <div class="top_list_li" @click="showLayer(1)">
        <div class="top_list_text_wrap">
          <p class="top_tit">
            当前火警数
          </p>
          <div class="top_sum huojing_sum default_color"></div>
        </div>
<!--        <img :src="quanImg" alt="">-->
      </div>
    </div>
  </div>
</template>
<script>
import quanImg from '@/assets/img/quan.png'

export default {
  name:"",
  data: () => ({
    quanImg: quanImg,
    flamingFireCount:0,
    alarmCount:0,
  }),
  props:[
    'chunjing',
    'topDate',
  ],
  watch: {
    topDate:{
      handler(res, oldVal){
        if(res){ //获取数据
          if(Object.keys(res[1]).length){
            //报警预警数据
            if(res[1].alarmCount!=null && res[1].alarmCount!=undefined){
              this.allSumInit(Math.abs(res[1].alarmCount), 'baojing_sum', 'bj_sum_box');
            }
            //火警数据
            if(res[1].flamingFireCount!=null && res[1].flamingFireCount!=undefined){
              this.allSumInit(Math.abs(res[1].flamingFireCount), 'huojing_sum', 'hj_sum_box');
            }
          }
        }
      },
      immediate: true,
      deep: true
    },
  },
  components: {

  },
  created() {

  },
  computed: {

  },
  mounted() {
  },
  methods: {
    showLayer(index){ //顶部4个圆点击，显示弹窗
      let obj = {
        status: true,
        type: 'midTop' + index
      }
      this.$store.commit('showLayer', obj);
    },
    allSumInit(data, parentName, childName){
      //思路
      //首先初始化，每一个数字都是ul里面包含了10个数字,分割字符串，用li包裹
      //传入值，针对每一个进行动画滚动,每一个数字高度为40px
      let res = String(data).split('');
      this.sumInit(res, parentName, childName)
      for(let i = 0; i < res.length; i++){
        let gundongSum = -res[i] * 40 + 'px';
        $('.' + parentName + ' .sum_wrap:nth-child(' + parseInt(i + 1) + ')').show();
        this.$nextTick(()=>{
          $('.' + parentName + ' .sum_wrap:nth-child(' + parseInt(i + 1) + ')').find('ul').css('transform','translateY(' + gundongSum + ')');
        });
      }
    },
    sumInit(data, parent, child){
      if($('.' + child).length != data.length){
        $('.' + parent).find('.sum_wrap').remove();
        for(let i = 0;i< data.length;i++){
          let html = `<div class="sum_wrap ${child}"><ul>
            <li>0</li>
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li>4</li>
            <li>5</li>
            <li>6</li>
            <li>7</li>
            <li>8</li>
            <li>9</li>
          </ul></div>`;
          $('.' + parent).prepend(html);
        }
        $('.' + parent).find('.sum_wrap').hide();
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.top_list_wrap{
    position: absolute;
    top: 140px;
    right: 500px;
    //width: calc(100% - 1000px);
    transition: all 1s;
    transform: translateY(0);
    text-align: center;
    z-index: 10;
    //.top_list_ul{
    //  display: flex;
    //  justify-content: space-around;
    //}
  .top_list_ul_right{
    /*width: 155px;*/
    position: relative;
  }
    .top_list_li{
      //flex: 1;
      //flex-shrink: 0;
      //overflow: hidden;
      position: relative;
      cursor: pointer;
      margin-bottom: 20px;
      img{
        //width: 160px;
        //height: 160px;
        //margin: 0 auto;
        //animation: move 10s linear infinite;
      }
      .top_list_text_wrap{
        z-index: 2;
        height: 78px;
        /*width: 155px;*/
        /*height: 160px;*/
        /*position: absolute;*/
        /*left: 0;*/
        margin-left: 0;
        display: -webkit-box;
        /*! autoprefixer: off*/
        -webkit-box-orient: vertical;
        /* autoprefixer: on*/
        -webkit-box-align: center;
        //-webkit-box-pack: center;
        background-image: url('../assets/img/quan.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 0 20px;
        .top_tit{
          font-size: 16px;
          margin-bottom: 10px;
          position: relative;
          bottom: 10px;
        }
        .top_sum{
          font-size: 28px;
          overflow: hidden;
        }
      }
    }
    //@keyframes move {
    //  0%{transform: rotate(0deg)}
    //  100%{transform: rotate(360deg)}
    //}
}
.yincang_active{
  transform: translateY(-200%);
}
</style>



// WEBPACK FOOTER //
// src/components/topRightList.vue